export default function AnniversaryScan(){
    return (
        <>
            <img src='scan-anniversary.jpg' style={{maxWidth:'100%'}} />
        </>
    )
}